import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DBAnalysisData } from '../../../model/analysis-details.model';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { StorageService } from '../../../service/storage.service';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss']
})
export class DetailsComponent implements OnInit, OnDestroy {
  userAttributes: any;
  signedInUser: any;
  illegalUser?:boolean;
  showTable=false;

  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort!: MatSort;

  userAccess?:string;

  dataSource?: MatTableDataSource<DBAnalysisData>;
  tableColumns: string[] = [ 'fileName','projectCode', 'analysisDate', 'status', 'userId','username','userrole'];
  @Input() searchResults: DBAnalysisData[] = [];

  constructor(
    private storageService:StorageService,
  ) {
  }

  ngOnInit() {
     this.showTable = true;
     this.userAccess=this.storageService.get('access')?.toLowerCase();
        this.dataSource = new MatTableDataSource(this.searchResults);
        setTimeout(() => this.dataSource!.paginator = this.paginator);
        setTimeout(() => this.dataSource!.sort = this.sort);
  }

  getUrl(analysisType: string) {
 if (analysisType === 'qPCR') {
      return '/default-layout/qpcr-molecule-analysis';
    }
    else {
      return '/default-layout/notfound';
    }
  }

  applyFilter(filterValue: string) {
    this.dataSource!.filter = filterValue.trim().toLowerCase();
  }

  openPDF() {
    const DATA: any = document.getElementById('reportData');
    html2canvas(DATA).then((canvas) => {
      const fileWidth = 208;
      const fileHeight = (canvas.height * fileWidth) / canvas.width;
      const FILEURI = canvas.toDataURL('image/png');
      const PDF = new jsPDF('p', 'mm', 'a4');
      const position = 0;
      PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight);
      PDF.save('Analysis-Report.pdf');
    });
  }

  ngOnDestroy() {
  }

}
